import type { Product } from '@/types/product';

function formatInr(amount: number): string {
  return `₹${amount.toLocaleString('en-IN')}`;
}

export function formatProductPriceRange(product: Product): string {
  const min = product.minPrice ?? product.regularPrice;
  const max = product.maxPrice ?? product.regularPrice;

  if (min == null && max == null) return '—';
  if (min == null || max == null) return formatInr(min ?? max ?? 0);
  if (product.productType === 'variable' && min !== max) {
    return `${formatInr(min)} – ${formatInr(max)}`;
  }
  return formatInr(min);
}

export function formatProductSalePriceRange(product: Product): string | null {
  const min = product.minSalePrice ?? product.salePrice;
  const max = product.maxSalePrice ?? product.salePrice;

  if (min == null && max == null) return null;
  if (min == null || max == null) return formatInr(min ?? max ?? 0);
  if (product.productType === 'variable' && min !== max) {
    return `${formatInr(min)} – ${formatInr(max)}`;
  }
  return formatInr(min);
}

export function getProductListStock(product: Product): number {
  // Admin General tab stock field (product.stock) is the source of truth.
  return product.stock ?? product.totalStock ?? 0;
}
